import React from 'react'

import { SelectChangeEvent } from '@mui/material/Select'
import { useStyles } from './ChooseTemplateModal.styles'
import {
  ModalConfirmV2,
  ModalSizeVariants,
  SelectV2,
} from '@labrav/react-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faExternalLinkAlt,
  faFileLines,
} from '@fortawesome/pro-regular-svg-icons'

export type ChooseTemplateModalTemplate = {
  templateId: string
  templateName: string
}

export type ChooseTemplateModalMarketplaceProps = {
  templateModal: boolean
  selectedTemplate: string
  handleContinueClick: () => void
  handleSkip: () => void
  handleTemplateSelectChange: (event: SelectChangeEvent) => void
  templates: ChooseTemplateModalTemplate[]
}

export const ChooseTemplateModalMarketplace: React.FC<
  ChooseTemplateModalMarketplaceProps
> = ({
  templateModal,
  selectedTemplate,
  handleContinueClick,
  handleSkip,
  handleTemplateSelectChange,
  templates,
}) => {
  const { classes } = useStyles()
  const originURL = window.location.origin
  const handleOpenTemplateInNewTab =
    (templateId: string) => (e: React.MouseEvent) => {
      e.stopPropagation()
      window.open(
        `${originURL}/settings/mappings/marketplace/templates/${templateId}?viewOnly=true`,
        '_blank'
      )
    }

  return (
    <div data-testid="choose-template-modal">
      <ModalConfirmV2
        title="Choose a template"
        icon={
          <FontAwesomeIcon
            icon={faFileLines}
            data-testid="file-lines-icon-modal"
          />
        }
        onlyCloseModal
        onCloseModal={handleSkip}
        content={
          <div className={classes.selectTemplateContainer}>
            <SelectV2
              field={{
                title: 'Select an option',
                placeHolder: 'Select an option',
                options: templates.map(
                  (template: ChooseTemplateModalTemplate) => ({
                    value: template?.templateId,
                    label: template?.templateName,
                    menuItemAction: (
                      <FontAwesomeIcon
                        className={classes.externalLinkIcon}
                        icon={faExternalLinkAlt}
                        onClick={handleOpenTemplateInNewTab(
                          template.templateId
                        )}
                      />
                    ),
                  })
                ),
              }}
              value={selectedTemplate ?? ''}
              onChange={handleTemplateSelectChange}
              onBlur={() => {}}
              isError={false}
              errorText="create-template"
              size="small"
              viewOnly={false}
            />
          </div>
        }
        open={templateModal}
        titleAcceptButton={'Continue'}
        onAccept={handleContinueClick}
        variant={ModalSizeVariants.medium}
        hideCancelButton={false}
        titleCancelButton="Skip"
        acceptDisabled={!selectedTemplate}
        onDecline={handleSkip}
      />
    </div>
  )
}
